import axios from 'axios';

import type { IForwardRep, IGenericUser, User } from '@bb/users';
import type {
  ISupraSystemSubscription,
  Override,
  Team,
} from '@bb/domain/dist/types';
import type { CachedOrg } from '@bb/automaton';
import type { JsonObject } from '@/app-package';
import type { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';

export type PopulatedUser = JsonObject<
  Omit<IGenericUser, 'org' | 'team' | 'frontEndInstructions'> & {
    _id: string; // JsonObject<ObjectId>
    org: CachedOrg;
    team: Team;
    frontEndInstructions: Override<
      User['frontEndInstructions'],
      { forwardReps?: (IForwardRep & User)[] }
    >;

    subscriptions?: {
      answeringSubscription?: boolean;
      supraSystemSubscription?: ISupraSystemSubscription;
    };
    canSubscribeToSupra?: boolean;
    supraPin?: string;
    adminNotes?: string;
    coopType?: SupraCoopType;
    coopRelationshipType?: string;
    isAutoCoopDisabled?: boolean;
    officeOids?: string[];
  }
>;

const getProfile = async (
  userId: string,
  options: {
    populateOrg?: boolean;
    populateTeam?: boolean;
    populateReps?: boolean;
    populateUserSubscriptions?: boolean;
    includeSubscriptionHistory?: boolean;
    populateAdminNotes?: boolean;
  },
) => {
  const config = {
    url: `/user/${userId}/profile`,
    method: 'get',
    params: options,
  };

  const { data } = await axios.request<PopulatedUser>(config);

  return data;
};

export default getProfile;
